// extracted by mini-css-extract-plugin
export default {"banner":"BgImage_banner__Np8Gu","tags":"BgImage_tags__wwuA-"};